module.exports = __webpack_public_path__ + "img/icon-eye.f6812314.svg";